<template>
  <div />
</template>

<script setup lang="ts">
const partner = usePartner()
const toaster = useToaster()
const displayedPopups = usePopups()
const redirection = useRedirection()

onMounted(() => {
  notifyInterchaletMigration()
})

function notifyInterchaletMigration() {
  if (!useFlag('interchalet-is-now-interhome-information').value) return
  if (!redirection.fromInterchalet.value && partner.id !== 'IH1000021') return
  if (displayedPopups.popups.interhomePopup) return

  toaster.untyped(h(resolveComponent('InterchaletMigrationPopup')), {
    delay: 300,
    duration: false,
    closeButton: 'top',
    onClose() {
      displayedPopups.update('interhomePopup', true)
    },
  })
}
</script>
